import { Dialog, DialogContent, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import * as api from "api/Core";
import { SpinnerIndicator } from "components/CallServer";
import { RequestErrorReport } from "components/CallServer/RequestErrorReport";
import IconTrophy from "components/Icons/IconTrophy";
import { JoinComponents } from "components/JoinComponents";
import MuiContainer from "components/MuiExtras/MuiContainer";
import MuiDialogTitleClose from "components/MuiExtras/MuiDialogTitleClose";
import MuiMessageBlock from "components/MuiExtras/MuiMessageBlock";
import MuiColor from "components/MuiExtras/Typography/MuiColor";
import MuiMuted from "components/MuiExtras/Typography/MuiMuted";
import { UserBadgeDto } from "models/ApiModels";
import * as React from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import Session from "services/Session";

/////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    userId: string;
    badgeId: string;
    onClose: () => void;
}

interface IState {
    data: UserBadgeDto;
    lastError: any;
    loading: boolean;
}

type Props = IProps & WithTranslation;

/////////////////////////////////////////////////////////////////////////////////////

class WonBadgeInfoDialog extends React.Component<Props, IState> {

    constructor(props: Props) {
        super(props);

        this.state = {
            data: null,
            loading: true,
            lastError: null
        };
    }

    ///
    private res(r: string, f: any = null) {
        return this.props.t("Views.Gamification.Dialogs.WonBadgeInfo." + r, f);
    }

    ///
    private load() {
        api.getUserWonBadge(this.props.userId, this.props.badgeId)
            .then((result) => {
                this.setState({ data: result, loading: false });
            })
            .catch((error) => {
                this.setState({ lastError: error, loading: false });
            });
    }

    ///
    private renderInfo() {
        const { data } = this.state;
        var notwontext = this.props.userId == Session.user.id ? "DidntWin1Text" : "DidntWin2Text";

        return (
            <div>
                {
                    data.isActive === false &&
                    <MuiContainer>
                        <MuiMessageBlock variant="error">{this.res("InactiveMedalMessage")}</MuiMessageBlock>
                    </MuiContainer>
                }
                <MuiContainer>
                    <Grid container spacing={2}>
                        <Grid item>
                            <img src={data.thumbnailUrl} alt={data.name} />
                        </Grid>
                        <Grid item xs >

                            <div>

                                <Typography variant="h4"><b>{data.name}</b></Typography>

                                <p><MuiColor variant="muted"><IconTrophy />{this.res("PointsText", { count: data.points })}</MuiColor></p>

                                {
                                    data.wonTotalPoints != null
                                        ? (
                                            <MuiColor variant="success">
                                                <p>{this.res("WonTimesText", { count: data.wonTimes, wonTotalPoints: data.wonTotalPoints, lastWon: data.wonLastDate })}</p>
                                            </MuiColor>
                                        )
                                        : (
                                            <MuiColor variant="muted">
                                                <p><b>{this.res(notwontext)}</b></p>
                                            </MuiColor>
                                        )
                                }

                            </div>
                        </Grid>
                    </Grid>
                </MuiContainer>

                <MuiContainer>
                    <MuiMuted>
                        <JoinComponents separator={<br />} components={data.description.split('\n')} />
                    </MuiMuted>
                </MuiContainer>

            </div>
        );
    }

    ///
    public componentDidMount() {
        this.load();
    }

    ///
    public render() {
        const { onClose } = this.props;
        const { lastError, loading } = this.state;

        return (
            <Dialog
                open
                fullWidth
                maxWidth="md"
                onClose={onClose}
            >
                <MuiDialogTitleClose onClose={onClose} />

                <DialogContent>
                    {
                        lastError
                            ? <RequestErrorReport error={lastError} />
                            : loading
                                ? <SpinnerIndicator />
                                : this.renderInfo()
                    }
                </DialogContent>
            </Dialog>
        );
    }
}

export default withTranslation()(WonBadgeInfoDialog);